import { render, staticRenderFns } from "./RC_behavior.vue?vue&type=template&id=58df5e08&scoped=true"
import script from "./RC_behavior.vue?vue&type=script&lang=js"
export * from "./RC_behavior.vue?vue&type=script&lang=js"
import style0 from "./RC_behavior.vue?vue&type=style&index=0&id=58df5e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58df5e08",
  null
  
)

export default component.exports